var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass.js");

var AnnoymousAuth = /*#__PURE__*/function () {
  "use strict";

  function AnnoymousAuth() {
    _classCallCheck(this, AnnoymousAuth);
  }

  _createClass(AnnoymousAuth, [{
    key: "authorize",
    value: function authorize() {// do nothing with request
    }
  }]);

  return AnnoymousAuth;
}();

module.exports = AnnoymousAuth;